export default "__VITE_ASSET__D61vm33f__"